// Mixpanel Token
export const MIXPANEL_TOKEN = '1c7ce9876de96d036ad15d8c4e55c5b1';
export const COOKIE_KEY_MIXPANEL = `mp_${MIXPANEL_TOKEN}_mixpanel`;
